module.exports = __webpack_public_path__ + "icon_yhteistyo.6954d3b929db9851b1bc.svg";